<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">
            <p-toast key="toastmsg"></p-toast>

            <div class="mainDivHeader">
                <div class="leftdiv">
                    <h4>Commission Report<span class="badge">{{totalRecords}}</span></h4>
                </div>

                <div class="rightDiv">
                    <button class="exportBTn" (click)="exportExcel()"> <span><img
                        src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
                    Export</button>
                    <!-- <button pButton pRipple label="Download Zip" icon="pi pi-file-excel" (click)="generateAndDownloadZip()"
                        class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button> -->
                </div>
            </div> 

            <div class="mainDivBody">
                <div class="date-filterDiv">
                    <ul class="filtersList">
                        <li>
                            <!-- <label for="searchfield">Select Field</label> -->
                            <p-dropdown id="financialYear" [options]="yourOptions" [(ngModel)]="searchby" optionLabel="label"></p-dropdown>
                        </li>
                        <li>
                            <!-- <label>Enter Amount <span class="mandatory-fields">*</span></label> -->
                            <input class="amountINput" pInputText type="text" [(ngModel)]="amount" value="50"/>
                        </li>
                        <li>
                            <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadWallet($event)"></button> -->
                            <button (click)="loadWalletHistory($event)" class="searchFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                            </button>
                        </li>
                        <li>
                            <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
                            <button (click)="clear()" class="clearFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                            <span>Clear All</span>
                            </button>
                        </li>
                    </ul>
                </div>

                <div class="maintableDiv">
                   <div class="tableParanet">
                    <p-table class="p2-table-columns show-columns" #dt [value]="walletlist" [paginator]="true" [rows]="10" 
                        [lazy]="true" (onLazyLoad)="loadWalletHistory($event)" [totalRecords]="totalRecords" [loading]="loading"
                        [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <!-- <th pSortableColumn="id" [style]="{'width':'120px'}">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Transaction ID
                                        <p-sortIcon field="id"></p-sortIcon>
                                    </div>
                                </th> -->
                                <th pSortableColumn="userData.fullName" [style]="{'width':'25%'}">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        User Name
                                        <p-sortIcon field="userName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="userData.email" [style]="{'width':'25%'}">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Email
                                        <p-sortIcon field="userEmail"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="userData.mobileNumber" [style]="{'width':'25%'}">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Mobile
                                        <p-sortIcon field="userMobile"></p-sortIcon>
                                    </div>
                                </th>
                                <!-- <th pSortableColumn="description" [style]="{'width':'120px'}">
                                    <div class="p-d-flex p-jc-between p-ai-center">Description</div>
                                </th> -->
                                <th pSortableColumn="sum" [style]="{'width':'25%'}">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Amount
                                        <p-sortIcon field="sum"></p-sortIcon>
                                    </div>
                                </th>
                                <!-- <th pSortableColumn="created_at" [style]="{'width':'120px'}">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Created Date
                                        <p-sortIcon field="created_at"></p-sortIcon>
                                    </div>
                                </th> -->
                                <!-- <th [style]="{'width':'100px'}">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Action
                                    </div>
                                </th> -->
                            </tr>
                            <tr>
                                <!-- <th [ngSwitch]="id">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'id', 'contains')"
                                        [value]="dt.filters['id'] ? dt.filters['id'].value : ''" />
                                </th> -->
                                <th [ngSwitch]="userName">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                                        [value]="dt.filters['userName'] ? dt.filters['userName'].value : ''" />
                                </th>

                                <th [ngSwitch]="userEmail">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userEmail', 'contains')"
                                        [value]="dt.filters['userEmail'] ? dt.filters['userEmail'].value : ''" />
                                </th>

                                <th [ngSwitch]="userMobile">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userMobile', 'contains')"
                                        [value]="dt.filters['userMobile'] ? dt.filters['userMobile'].value : ''" />
                                </th>
                                <!-- <th [ngSwitch]="description" class="statusTd">
                                    <p-dropdown appendTo="body" #pDropDownId [options]="description"
                                    (onChange)="setDownloadFlag(); dt.filter($event.value, 'description', 'equals')" placeholder="Select Description"
                                    [showClear]="true">
                                    <ng-template let-option pTemplate="item">
                                        <span [class]="'customer-badge description-' + option.value">{{option.label}}</span>
                                    </ng-template>
                                    </p-dropdown>
                                </th> -->
                                <th [ngSwitch]="sum" class="">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'sum', 'contains')"
                                        [value]="dt.filters['sum'] ? dt.filters['sum'].value : ''" />
                                </th>
                                <!-- <th [ngSwitch]="created_at" class="">
                                </th>
                                <th class="">
                                </th> -->
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-userwallet>
                            <tr class="p-selectable-row">
                                <!-- <td>
                                    {{userwallet.id}}
                                </td> -->
                                <td>
                                    {{userwallet?.userName}}
                                </td>
                                <td>
                                    {{userwallet?.userEmail}}
                                </td>
                                <td>
                                    {{userwallet?.userMobile}}
                                </td>
                                <td>
                                    {{userwallet.sum}}
                                </td>
                                <!-- <td *ngIf="userwallet.coins!=0">                                    
                                    <div class="debit" *ngIf="userwallet.action=='ADD'">
                                        <i class='pi pi-plus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase }}<span></span>
                                    </div>
                                    <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                        <i class='pi pi-minus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase}} <span></span>
                                    </div>
                                    
                                </td>
                                <td *ngIf="userwallet.cash!=0">
                                    <div class="debit" *ngIf="userwallet.action=='ADD'">
                                        <i class='pi pi-plus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}}<span></span>
                                    </div>
                                    <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                        <i class='pi pi-minus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}} <span></span>
                                    </div>
                                </td> -->
                                <!-- <td *ngIf="userwallet.action=='ADD'">
                                    <i class='pi pi-plus'></i> {{userwallet.amount}} {{userwallet.wallettype | lowercase }}
                                </td>
                                <td *ngIf="userwallet.action=='SUBTRACT'">
                                    <i class='pi pi-minus'></i> {{userwallet.amount}} {{userwallet.wallettype | lowercase }}
                                </td>
                                <td>
                                    {{userwallet.created_at | date:'d/M/yyyy'}}
                                </td> -->
                                <!-- <td> -->
                                <!-- <button *ngIf="userwallet.created_by === loggedInUserId" pButton pRipple icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger p-mr-2 p-mt-2"
                                        (click)="deleteUserWalletEntry(userwallet)" pTooltip="Delete User Wallet Entry"
                                        tooltipPosition="bottom"></button> -->
                                <!-- <i *ngIf="userwallet.invoiceFile"   pTooltip="Click to view Invoice PDF" class="bx bxs-file-pdf" style="color: red; font-size: 18px" (click)="downloadPdf(userwallet.invoiceFile)"></i> -->
                                <!-- </td> -->

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="5">No Commission History.</td>
                            </tr>
                        </ng-template>
                        <!-- <ng-template pTemplate="summary">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                In total there are {{totalRecords }} User Invoices History.
                            </div>
                        </ng-template> -->
                    </p-table>
                  </div>
                </div>    
            </div>        




    </div>
</div>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>